/**
 * Created by Mark on 24/04/2017.
 */


import React from "react";
import { FormattedMessage } from 'react-intl';
import LineGraph from '../../graphs/base/LineGraph.js';
import AssignStudents from '../../wizard/create-class-steps/review-students.js';
import ClassService from '../../../services/classes-service.js';
import RecentAcitvity from '../../activity-widget.js';
import ClassStore from '../../../store/classes-store.js';
import {Col , Row , Button , Table} from 'react-bootstrap';
import Select from  'react-select';
import DateInput from '../../inputs/date.input.js';
import StudentServices from '../../../services/student-services.js';
import StudentStores from '../../../store/student-store.js';
import InternationalizationStore from '../../../store/internationalization-store.js';
import InternationalizationServices from '../../../services/internationalization-service.js';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import LanguageServices from '../../../services/language-services.js';
import LanguageStore from '../../../store/language-store.js';
import Download from "../../../classes/download.js";
import DateFormat from '../../../classes/date.js';

class AboutPanel extends React.Component {

    constructor(props){
        super();

        var d =   new Date();
        var due = new Date(); due.setMonth(due.getMonth() - 6);

        let to  =  d.getUnixTime();
        let from  = due.getUnixTime();

        this.props = props
        this.state ={
            recentActivity:[],
            languageValue:{ value: "all", label: "ALL"},
            languages:[],
            to:to,
            from:from,
        }

        this.handelSetFromDateSelect = this.handelSetFromDateSelect.bind(this);
        this.handelSetToDateSelect   = this.handelSetToDateSelect.bind(this)
    }

    componentDidMount(){
        StudentServices.getStudent(this.props.data.studentID);
        StudentServices.getStudentLanguages(this.props.data.studentID);
        InternationalizationServices.getUserTranslations(InternationalizationStore.determineLocaleFromBrowser());
        this.getData(this.state.from , this.state.to , this.state.languageValue.value);
    }

    componentWillMount(){
        StudentStores.on('STUDENT_UPDATE' , () => {
            this.setState({student:StudentStores.student});
        });

        StudentStores.on('STUDENT_LANGUAGE_UPDATE' , () => {
            this.setState({languages:StudentStores.studentlanguages});
        });

        InternationalizationStore.on("CHANGE" , () => {
            this.setState({got:true});
        });

        StudentStores.on("UPDATE_STUDENT_ACTIVITY" , () => {
            this.setState({
                recentActivity:StudentStores.studentActivity
            });
        });
    }


    getData(from , to , languageValue){
        StudentServices.getStudentRecent(this.props.data.studentID , from , to , languageValue);
    }


    onLanguageSelect(object){


        this.setState({
            languageValue:object
        });

        console.log(this.state.from);
        this.getData(this.state.from , this.state.to , object.value);
    }


    handelSetFromDateSelect(val){
        let from = (new Date(val)).getUnixTime();
        this.setState({from:from});
        this.getData(from , this.state.to , this.state.languageValue.value);
    }

    handelSetToDateSelect(value){
        let to = (new Date(value)).getUnixTime();
        this.setState({to:to});
        this.getData(this.state.from , to , this.state.languageValue.value);
    }

    downloadCustomThing() {
        var finalData = [];

        var STUDENT = InternationalizationStore.getTranslation('ui-14' , 'notfound');
        var SCORE   = InternationalizationStore.getTranslation('ui-229' , 'notfound');

        var csvData = STUDENT+","+SCORE+" \n";
        for (var x = 0; x < this.state.recentActivity.length; x++) {
            var dataField = this.state.recentActivity[x];
            if (finalData[dataField.name] == undefined) {
                finalData[dataField.name] = 0;
            }
            finalData[dataField.name] += parseInt(dataField.score);
        }

        var keys = Object.keys(finalData);
        keys.sort(function(a,b) {
            var aVal = finalData[a];
            var bVal = finalData[b];
            if(aVal > bVal) return -1;
            if(aVal < bVal) return 1;
            return 0;
        });

        for (var x= 0; x < keys.length; x++) {
            csvData += keys[x] + "," +finalData[keys[x]]+" \n";
        }
        new Download().download_csv(csvData, "classGrouping.csv");
    }

    getStudentName() {
        return <FormattedMessage id={ 'ui-827' } defaultMessage={ 'Student Name' }/>;
    }

    getScoreName() {
        return <FormattedMessage id={ 'ui-229' } defaultMessage={ 'Score' }/>;
    }

    getTableData(){

        var index = 0;

        var getMedal = function(score){

            if(score < 50) return '-';
            if(score < 70) return InternationalizationStore.getTranslation('ui-269' , 'notfound');
            if(score < 90) return InternationalizationStore.getTranslation('ui-270' , 'notfound');

            return InternationalizationStore.getTranslation('ui-271' , 'notfound');
        }


        return this.state.recentActivity.map(function(activity){

            var test = "-";
            switch(String(activity.is_test)){
                case "1":
                    test=  InternationalizationStore.getTranslation('ui-114' , 'notfound'); break;
                case "0":
                    test =  InternationalizationStore.getTranslation('ui-113' , 'notfound'); break;
                default:
                    return "-";
            }

            var skill = InternationalizationStore.getTranslation('ui-113' , 'notfound');

            if(activity.type == "game")
            {
                skill = this.getSkillTranslation(activity.skill);
            }
            else
            {
                switch(activity.type){
                    case "verb" : skill = InternationalizationStore.getTranslation('ui-1026' , 'notfound'); break;
                    case "sentence" : skill = InternationalizationStore.getTranslation('ui-89' , 'notfound'); break;
                    case "grammer" : skill = InternationalizationStore.getTranslation('ui-100' , 'notfound'); break;
                }

            }

            var zeroFill = function( number, width ) {
                width -= number.toString().length;
                if ( width > 0 )
                {
                    return new Array( width + (/\./.test( number ) ? 2 : 1) ).join( '0' ) + number;
                }
                return number + ""; // always return a string
            };

            var toTimeString = function(timeStamp){

                timeStamp = Number(timeStamp);

                var decisecond = Math.floor((timeStamp/10000));
                var seconds=Math.floor((timeStamp/1000)%60);
                var minutes=Math.floor((timeStamp/(1000*60))%60);
                var hours=Math.floor((timeStamp/(1000*60*60))%24);

                return zeroFill(hours , 2) +":"+zeroFill(minutes , 2) + ":" + zeroFill(seconds , 2)
            };



            return {
                id:index++,
                language:activity.ietf,
                name:activity.name,
                skill:skill,
                section:activity.type == "verb" ? activity.title : InternationalizationStore.getModuleNoIndexTranslation(activity.module_uid),
                score:activity.score,
                medal: activity.is_test == "1" ? getMedal(activity.precentage) : '-',
                type:test,
                time:toTimeString(activity.time),
                date_time:(new DateFormat()).format(activity.date_time)
            }
        }.bind(this));
    }

    languageImage(cell, row) {
        return <img className="avatar-img" src={"img/flags/"+cell+".png"} alt=""/>
    }

    getSkillTranslation(cell){

        var text = [InternationalizationStore.getTranslation('ui-119' , 'notfound') , InternationalizationStore.getTranslation('ui-117' , 'notfound') , InternationalizationStore.getTranslation('ui-118' , 'notfound'), InternationalizationStore.getTranslation('ui-120' , 'notfound')]

        switch(cell){
            case "reading":
                return text[0]
            case "listening":
                return text[1]
            case "speaking":
                return text[2]
            case "writing":
                return text[3]
            default:
                return "-";
        }
    }


    getTestTranslation(cell){

        var text = [InternationalizationStore.getTranslation('ui-119' , 'notfound') , InternationalizationStore.getTranslation('ui-117' , 'notfound') , InternationalizationStore.getTranslation('ui-118' , 'notfound'), InternationalizationStore.getTranslation('ui-120' , 'notfound')]

        switch(cell){
            case "1":
                return InternationalizationStore.getTranslation('ui-114' , 'notfound')
            case "0":
                return InternationalizationStore.getTranslation('ui-113' , 'notfound')
            default:
                return "-";
        }
    }

    createCustomExportCSVButton = (onClick) => {
        return <button  onClick={ onClick } className="btn  btn-primary b-btn-icon-text waves-effect pull-right"><i className="palette-White text zmdi zmdi-download"></i>  <FormattedMessage id={ String("ui-474")} defaultMessage={ "Download Report" } /></button>
    }

    createCustomToolBar = props => {

        const options = this.state.languages.map(function(language){
            return  { value: language.ietf, label: language.getName()}
        });
        if (options.length > 1) {
            options.push({ value: "all", label: "ALL"});
        } else if (options.length == 1) {
            this.state.languageValue = options[0];
        }

        return <div className="pmbb-header m-b-0 p-t-30 p-r-30 p-l-30 m-l-10 m-r-10">

            <Row className="row">
                <Col  sm={9}>
                    <h2>{this.state.className} <FormattedMessage id={ 'ui-466' } defaultMessage={ 'Recent Activity' }/></h2>
                </Col>
                <Col  sm={3}>

                </Col>
            </Row>
            <Row className="p-t-10">
                <Col sm={6}>
                    <div className="form-group fg-line">
                        <label className="fg-label control-label">
                            <FormattedMessage id={"ui-492"} defaultMessage={"Select Language"}/>
                        </label>
                        <Select multi={false} disabled={this.state.languages.length <= 1} onChange={this.onLanguageSelect.bind(this)}
                                value={this.state.languageValue} options={options} noResultsText={<FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found" }/>}
                                placeholder={<FormattedMessage id={ 'ui-892' } defaultMessage={ 'Select' }/>}/>
                    </div>
                </Col>
                <Col  sm={3}>
                    <DateInput onSelect={this.handelSetFromDateSelect} value={this.state.from} labelTranslationUID={"ui-698"}/>
                </Col>
                <Col  sm={3}>
                    <DateInput onSelect={this.handelSetToDateSelect} value={this.state.to} labelTranslationUID={"ui-699"}/>
                </Col>
            </Row>
            <Row className="row">
                <Col  sm={4}>

                </Col>
                <Col  sm={8}>
                    <div className="pull-right">
                        { props.components.btnGroup }

                    </div>
                </Col>
            </Row>

        </div>;

        return (
            <div style={ { margin: '15px' } }>
                { props.components.btnGroup }

                <div className='col-xs-8 col-sm-4 col-md-4 col-lg-2'>
                    { props.components.searchPanel }
                </div>
            </div>
        );
    };

    renderPaginationPanel = (props) => {
        return (
            <div className="row p-l-20 p-r-20">
                <div className="col-sm-6">{ props.components.pageList }</div>
            </div>
        );
    }

    render(){



        const tableOptions = {
            page: 1,  // which page you want to show as default

            sizePerPage: 10,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationShowsTotal: false,
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            hideSizePerPage: true,
            exportCSVBtn: this.createCustomExportCSVButton,
            toolBar: this.createCustomToolBar.bind(this),
            paginationPanel: this.renderPaginationPanel,
            alwaysShowAllBtns: true, // Always show next and previous button
            withFirstAndLast:true,
            firstPage: '...', // First page button text
            lastPage: '...', // Last page button text
            noDataText: InternationalizationStore.getTranslation('ui-2011' , '  '),
        };


        return (
            <div id="ClassRecentActivity">
                <div className="pmb-block p-t-10 p-0">
                    <BootstrapTable csvFileName={InternationalizationStore.getTranslation('ui-466' , 'recent-activity') + ".csv"} options={tableOptions} data={ this.getTableData() } keyField='id'  condensed pagination exportCSV striped bordered={ false }>
                        <TableHeaderColumn  col='0' colSpan='1' row='0' rowSpan='1'  dataField='language'  dataFormat={this.languageImage} colSpan='1' dataSort={ false }><FormattedMessage id={ 'ui-492' } defaultMessage={ 'Language' }/></TableHeaderColumn>
                        <TableHeaderColumn  col='0' colSpan='1' dataField='date_time'   dataSort={ false }><FormattedMessage id={ 'ui-322' } defaultMessage={ 'When' }/></TableHeaderColumn>
                        <TableHeaderColumn  col='0' colSpan='1' dataField='skill'   dataSort={ false }><FormattedMessage id={ 'ui-144' }  defaultMessage={ 'Skill' }/></TableHeaderColumn>
                        <TableHeaderColumn  col='0' colSpan='1' dataField='section' dataSort={ false }><FormattedMessage id={ 'ui-143' } defaultMessage={ 'Section' }/></TableHeaderColumn>
                        <TableHeaderColumn  col='0' colSpan='1' dataField='type'   dataSort={ false }><FormattedMessage id={ 'ui-2013' } defaultMessage={ 'Type' }/></TableHeaderColumn>
                        <TableHeaderColumn  col='0' colSpan='1' dataField='score'  dataSort={ false }><FormattedMessage id={ 'ui-229' } defaultMessage={ 'Score' }/></TableHeaderColumn>
                        <TableHeaderColumn  col='0' colSpan='1' dataField='medal'   dataSort={ false }><FormattedMessage id={ 'ui-2017' } defaultMessage={ 'Medal' }/></TableHeaderColumn>
                    </BootstrapTable>
                </div>
                <div className="pmbb-header">


                </div>
            </div>
        );
    }
}





export default {
    name: <FormattedMessage id={ 'ui-466' } defaultMessage={ 'Recent Activity' }/>,
    component: AboutPanel
}


// WEBPACK FOOTER //
// ./src/components/profile/profile-tabs/recent-student-panel.js